/**
 * Club elegido en el panel del club (cuentas que operan más de uno). Se
 * recuerda por usuario en este navegador; si el almacenamiento no está
 * disponible (modo privado, bloqueado) simplemente no se recuerda.
 */
const KEY_PREFIX = "t123.club-panel.club.";

export function readStoredClubId(userId: number | string | null | undefined): number | null {
  if (userId == null) return null;
  try {
    const raw = window.localStorage.getItem(`${KEY_PREFIX}${userId}`);
    const value = raw ? Number(raw) : NaN;
    return Number.isInteger(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function storeClubId(userId: number | string | null | undefined, clubId: number | null): void {
  if (userId == null) return;
  try {
    if (clubId == null) window.localStorage.removeItem(`${KEY_PREFIX}${userId}`);
    else window.localStorage.setItem(`${KEY_PREFIX}${userId}`, String(clubId));
  } catch {
    // Sin almacenamiento: la elección dura solo esta visita.
  }
}
